module dg.templates {
    angular.module('dg.templates', []);
}